module.exports = __webpack_public_path__ + "img/infra.d86a72f9.svg";